import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy, ChangeDetectorRef, Renderer2, ElementRef, NgZone } from '@angular/core';
import { NewTask, TaskData, TaskFunctions } from '../tasksData';
import { ColorList } from 'app/bars/topbar/topbarData';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { CasePriority } from 'app/settings/category-setup/category-setup.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as api from '../../shared/api/apihandler';
import { ActivityType } from 'app/activities/activities';
import { FileFunctions } from 'app/shared-html-components/case-files/case-files-functions';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { GetOffer } from 'app/shared-html-components/document-creator/productGrid';
import { ActionApi, ActionUtils, TaskTimeSpent, TaskTimeSpentFull, TimeSpentTime } from 'app/shared/api/actionApi';
import { DateUtilities } from 'app/shared/utilities/dateUtilities';
import { Dates } from 'app/shared/utilities/shared.functions';
import { ActionService } from 'app/shared/services/action.service';
import { UserService } from 'app/shared/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { DateUtilities as DatePicks } from 'app/shared/utilities/dateUtilities';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'task-item-slider',
  templateUrl: './task-item-slider.component.html',
  styleUrls: ['./task-item-slider.component.css']
})
export class TaskItemSliderComponent implements OnInit, OnChanges, OnDestroy {
  bsConfig = DatePicks.bsConfig;
  fileApi = new FileFunctions(this.http);
  api = new ActionApi(this.http);
  dateUtils = new DateUtilities();
  @Input() item: TaskData | null = new TaskData();
  @Output() itemChange = new EventEmitter<TaskData>();
  @Input() case;
  @Input() service: boolean = false;
  @Input() taskId: string;
  @Output() saved = new EventEmitter<boolean>();
  companyInfo;
  loading: boolean = true;
  priorities: Array<CasePriority>;
  responsibles;
  activityTypes: ActivityType[];
  priceGroups;
  users;
  propertyAddress: string | null = null;
  dueTimes = Dates.dueTimes; 
  durationTimes = Dates.durationTimes;
  dueDate: Date;
  dueTime: string | null = null;
  duration: string | null = null;
  viewFile;
  user = localStorage.getItem('bearer');
  showRecurring: boolean = false;
  subscriptions = {};
  hasTimeRegistry = !!JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'TaskTimeRegistry')
  registerTime: boolean = false;
  timeSpent: TaskTimeSpentFull[];
  newTimeSpentStart = new TimeSpentTime();
  newTimeSpentStop = new TimeSpentTime();
  newTimeSpent: TaskTimeSpent;
  editTimeSpent: TaskTimeSpentFull;
  editTimeSpentStart = new TimeSpentTime();
  editTimeSpentStop = new TimeSpentTime();
  deleteTimeSpent:boolean = false;
  taurus: boolean = false;
  toBeDeleted: boolean = false;
  canDeleteTask: boolean = false;
  missingImages: boolean = false;
  test:boolean = false;
  displayDoc;

  constructor(private sharedData: SharedDataService, private http: HttpClient, private router: Router, private actionService: ActionService, private userServer: UserService, private translate: TranslateService) { }

  ngOnInit() {
    this.onLoad();
  }

  onLoad() {
    this.subscriptions['priorities'] = this.sharedData.priorities().subscribe(data => { 
      this.priorities = data.sort((a,b) => {
        if(!a.sortOrder) return -1;
        if(!b.sortOrder) return -1;
        return a.sortOrder - b.sortOrder;
      });
    }) as Subscription;
    this.subscriptions['responsibles'] = this.sharedData.responsibles().subscribe(data => this.responsibles = data ) as Subscription;
    this.subscriptions['priceGroups'] = this.sharedData.priceGroups().subscribe(data => this.priceGroups = data) as Subscription;
    this.subscriptions['companyUsers'] = this.sharedData.companyUsers().subscribe(data => this.users = data) as Subscription;
    this.subscriptions['CompanyInfo'] = this.sharedData.companyInformation().subscribe(data => {this.companyInfo = data; this.taurus = data.id == '2605daad-d63b-4ccb-9c35-bce53c4becd4' || data.id == 'ba77f5ff-fbad-4676-bc41-e3ef567ca905';}) as Subscription;
    this.getActivityTypes();
  }

  ngOnChanges(c: SimpleChanges) {
    this.toBeDeleted = false;
    this.missingImages = false;
    if (c.item && c.item.currentValue && c.item.currentValue != c.item.previousValue) {
      // console.log(this.item)
      this.loading = true;
      this.canDeleteTask = c.item.currentValue.createdBy.id == localStorage.getItem('bearer') || !!JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'SettingsAccess');
      this.convertDateTimeToShow();
      this.getFiles();
      this.getTimeSpent();
    } else if (c.taskId && c.taskId.currentValue) {
      this.loading = true;
      this.api.getActivityById(this.taskId).subscribe({
        next: (data: any) => {
          this.item = data;
          //this.itemChange.emit(data);
        },
        error: err => console.error(err),
        complete: () => {
          this.loading = false;
        }
      })
    }
  }

  ngOnDestroy(): void { for (let x of Object.keys(this.subscriptions)) this.subscriptions[x].unsubscribe(); }

  getActivityTypes() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<ActivityType[]>(api.jubloApi + 'api/Activity/ActivityTypes', { headers }).subscribe({
      next: (data) => { 
        this.activityTypes = data.sort((a,b)=>{
          if(!a.name || !b.name) return !a.name ? 1 : -1;
          a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
      })
    }
  });
  }

  convertDateTimeToShow() {
    let h;
    if (!!this.item.durationInMinutes) {
      h = (this.item.durationInMinutes / 60).toString();
    }
    if (!!h && h.length == 1) {
      this.duration = '0' + h + ':00';
    } else if (!!h && h.length > 1) {
      this.duration = '0' + h.slice(0, 1) + ':' + (h.slice(-2) == '25' ? '15' : (h.slice(-2) == '75' ? '45' : '30'));
    }
    if (!!this.item.dueDateTime) {
      let dateData = TaskFunctions.splitDateTime(this.item.dueDateTime);
      this.dueDate = new Date(this.item.dueDateTime);
      this.dueTime = dateData.time != '23:59' ? dateData.time : null;
      }
    this.loading = false;
  }

  createNewTask() {
    this.actionService.copyTask(this.item as TaskData);
    document.getElementById('newTaskItemSliderModalBtn').click();
  }

  async updateTask() {
    let offset = new Date().getTimezoneOffset();
    const [hours, minutes] = this.dueTime.split(':');
    let date = this.dueDate;
    date.setHours(+hours);
    date.setMinutes(+minutes - offset);
    this.item.dueDateTime = date.toISOString();

    if (!!this.duration) {
      this.item.durationInMinutes = +((+this.duration.slice(0, 2) * 60) + (+this.duration.slice(-2)));
    }
    setTimeout(() => this.saveTask(''), 200);
  }

  updateStatus(isDone: boolean, createNew: boolean) {
    if (this.taurus && this.item.files.length == 0 && !this.test) {
      this.missingImages = true;
      return;
    }

    let status = isDone ? '8a7883dd-21b7-41ee-9e6e-b0e11992eb18' : (new Date(this.item.dueDateTime).getTime() > new Date().getTime() ? '7cb83847-96ee-4567-8555-b9d770ff16c0' : 'd5c65de3-8452-43f0-861e-c9cc8c36b744');
    if (isDone && !!this.item.recurrance) this.createRecurringTask();

    this.saveTask(status);
    document.getElementById('editTaskItemSliderModalCloseBtn').click();

    if (createNew) { this.createNewTask(); }
  }

  cancelActivity() {
    console.log('cancel activity');
  }

  async saveTask(updateStatus: string) {
    let status = !!updateStatus ? updateStatus : this.item.status.id;
    let data = {
      "subject": this.item.subject,
      "activityType": this.item.activityType.id,
      "status": status,
      "customerId": !!this.item.customer ? this.item.customer.customerId : null,
      "caseId": this.item.caseId,
      "offerId": this.item.offerId,
      "dueDate": null, // deprecated
      "dueTime": null, // deprecated
      "description": this.item.description,
      "durationInMinutes": this.item.durationInMinutes,
      "assignedToStakeholder": this.item.assignedToStakeholder.id,
      "dueDateTime": this.item.dueDateTime,
      "propertyId": this.item.propertyId,
      "propertyLeaseId": this.item.propertyLeaseId,
      "recurrance": this.item.recurrance,
      "note": this.item.note,
      "dvCategoryId": this.item.dvCategoryId,
      "dvAccountPlanId": this.item.dvAccountPlanId,
      "mandatory": this.item.mandatory,
      "priorityId": !!this.item.priority ? this.item.priority.id : null,
      "partnerCompanyId": !this.item.partnerCompanyId || this.item.partnerCompanyId == 'null' ? null : this.item.partnerCompanyId
    };
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.put(api.jubloApi + 'api/Activity/' + this.item.id, data, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.saved.emit(true);
      }
    });
  }

  async createRecurringTask() {
    const date = await this.dateUtils.getNextDateInRule(this.item.recurrance, new Date(this.item.dueDateTime));
    const recurrance = await this.dateUtils.updateRule(this.item.recurrance, date);
    const dueDateTime = await date.toISOString();
    let newItem = ActionUtils.activityToNewActivity(this.item, dueDateTime, recurrance);
    this.api.postActivity(newItem).subscribe({
      error: (err) => console.error(err)
    })
  }

  exchangeResponsibleName() {
    let r = this.responsibles.find(x => x.key == this.item.assignedToStakeholder.id);
    this.item.assignedToStakeholder.name = r.value;
  }

  findUser(name) {
    return name.substring(0, 1).toUpperCase();
  }

  getTimeLength(time:TaskTimeSpent){
    let t = Dates.getTimeDifference(time.startTime,time.endTime);
    return `${(t.hours).toString().padStart(2,'0')}:${t.minutes.toString().padStart(2,'0')}`
  }

  findColor(type, name) {
    if (!!this.item) {
      let init = !!this.item.customer && !!this.item.customer.name ? this.item.customer.name.trim().substring(0, 1).toUpperCase() : '';
      let responsible = !!this.item.assignedToStakeholder && !!this.item.assignedToStakeholder.name ? this.item.assignedToStakeholder.name.trim().substring(0, 1).toUpperCase() : '';
      if (name == '') {
        switch (type) {
          case 'b':
            if (!!init) {
              return ColorList.colors[init].background;
            } else {
              return '#1F539F';
            }
          case 'c':
            if (!!init) {
              return ColorList.colors[init].color;
            } else {
              return 'white';
            }
          case 'rb':
            if (!!responsible) {
              return ColorList.colors[responsible].background;
            } else {
              return '#1F539F';
            }
          case 'rc':
            if (!!responsible) {
              return ColorList.colors[responsible].color;
            } else {
              return 'white';
            }
          case 'rl':
            if (!!responsible) {
              return responsible;
            } else {
              return '';
            }
          default:
            if (!!init) {
              return init;
            } else {
              return '';
            }
        }
      } else {
        if (!name) return;
        init = name.trim().substring(0, 1).toUpperCase();
        switch (type) {
          case 'b':
            if (!!init) {
              return ColorList.colors[init].background;
            } else {
              return '#80b8f2';
            }
          case 'c':
            if (!!init) {
              return ColorList.colors[init].color;
            } else {
              return 'white';
            }
          default:
            if (!!init) {
              return init;
            } else {
              return '';
            }
        }
      }
    }
  }

  getFiles() {
    this.fileApi.getFilesOnTask(this.item.id).subscribe({
      next: (files) => this.item['files'] = files,
      error: (err) => console.warn('Could not load task images', err),
      complete: () => { if (this.item.files.length > 0) this.missingImages = false; }
    });
  }

  getTimeSpent() {
    this.api.getTimeSpentOnActivity(this.item.id).subscribe({
      next: (timeSpent: TaskTimeSpentFull[]) => {
        this.timeSpent = timeSpent;
      }
    })
  }

  resetTimeRegisters() {
    this.newTimeSpentStart = new TimeSpentTime();
    this.newTimeSpentStop = new TimeSpentTime();
    this.newTimeSpentStart.dateTime = new Date().toISOString();
    this.newTimeSpentStop.dateTime = new Date().toISOString();
    this.newTimeSpent = {
      activityId: this.item.id,
      stakeholderId: this.user,
      startTime: this.newTimeSpentStart.dateTime,
      endTime: null,
      description: '',
      priceGroupId: this.priceGroups.find(x => x.name == 'Standard')?.priceGroupId
    }
    if(this.timeRegistry){
      let a = document.getElementById('editTaskModalBody');
      a.scrollTop = 0;
    }
  }

  timeRegistry() {
    this.newTimeSpent.startTime = this.newTimeSpentStart.dateTime;
    this.newTimeSpent.endTime = this.newTimeSpentStop.dateTime;
    this.api.addTimeSpent(this.newTimeSpent).subscribe({
      next: () => {
        this.resetTimeRegisters();
      },
      error: (err) => console.error("Something went wrong", err),
      complete: () => {
        this.registerTime = false;
        this.getTimeSpent();
      }
    })
  }

  editTime(time){
    this.editTimeSpentStart.dateTime = time.startTime;
    this.editTimeSpentStop.dateTime = time.endTime;
    this.editTimeSpent = time;
    let a = document.getElementById('editTaskTimeSliderModalBtn');
    a.click();
  }

  updateTimeRegistration(){
    this.editTimeSpentStop.setMyDate(this.editTimeSpentStart.date);
    this.editTimeSpent.startTime = this.editTimeSpentStart.dateTime;
    this.editTimeSpent.endTime = this.editTimeSpentStop.dateTime;
    let taskTime = ActionUtils.convertToTaskTimeSpent(this.editTimeSpent);
    this.api.updateTimeSpent(taskTime).subscribe({
      complete:()=> this.getTimeSpent()
    })
  }

  deleteTaskTimeSpent(){
    this.api.deleteTimeSpent(this.editTimeSpent.id).subscribe({
      complete:() => {
        this.deleteTimeSpent = false;
        this.getTimeSpent();
      }
    })
  }

  makeRecurrance() {
    this.item.recurrance = 'RRULE:FREQ=DAILY;INTERVAL=7;WKST=MO';
    this.showRecurring = true;
  }

  imgDrop(files) {
    if (files.length > 0) {
      for (let f of files) {
        this.fileApi.uploadFile(f).subscribe({
          next: (data: any) => {
            this.fileApi.fileToTask(data.fileId, this.item.id).subscribe({
              next: () => this.getFiles(),
              error: (err) => console.warn("Could'nt attach file to task", err)
            })

          },
          error: (err) => console.warn('File upload failed')
        })

      }
    }
  }

  openViewModal(index) {
    this.viewFile = this.item.files[index];
    document.getElementById('editTaskViewFileModalOpener').click();
    // do something with the index
  }

  getURL(id) {
    return api.jubloApi + 'api/shared/attachments/' + id + '?userId=' + localStorage.getItem('bearer');
  }

  reccuranceChange(event) {
    if (event == null) {
      this.showRecurring = false;
      this.item.recurrance = null;
    } else if (typeof event === 'string' && event.startsWith('RRULE')) {
      this.item.recurrance = event;
    }
  }

  goToCase(caseId: string | null) {
    if (caseId) this.router.navigate(['/', 'Details', caseId]);
  }

  goToOffer(id: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get(api.jubloApi + 'api/Website/Offer/' + id, { headers }).subscribe({
      next: (offer: GetOffer) => this.router.navigate(['/', 'Details', offer.caseId])
    })
  }

  dateChanged(event: Date) {
    this.dueDate = event;
    if(!!event && this.dueTime) this.item.dueDateTime = DatePicks.mergeDateAndTime(event, this.dueTime).toISOString();
    if (event > new Date)  this.item.status.id = '7cb83847-96ee-4567-8555-b9d770ff16c0';
    else if (event < new Date) this.item.status.id = 'd5c65de3-8452-43f0-861e-c9cc8c36b744';
  }

  deleteTask() {
    this.api.deleteActivity(this.item.id).subscribe({
      next: () => this.saved.emit(true)
    })
  }

  cancelTask() {
    if (!!this.item.recurrance) this.createRecurringTask();
    this.saveTask('575cad61-42a1-48e1-9c2c-6e1fd1cd9026');
    document.getElementById('editTaskItemSliderModalCloseBtn').click();
  }

  async convertDate(date: Date) {
    return date.toISOString().split('T')[0];
  }

  indexOf(id) {
    let files = this.item.files.filter(x => x.type == 'file').map(x => x.id);
    return (files.indexOf(id) + 1) + ' ' + this.translate.instant('Word.Of').toLowerCase() + ' ' + files.length
  }

  notFirstFile(id) {
    let files = this.item.files.filter(x => x.type == 'file').map(x => x.id);
    return files.indexOf(id) != 0;
  }

  notLastFile(id) {
    let files = this.item.files.filter(x => x.type == 'file').map(x => x.id);
    return files.indexOf(id) != files.length - 1;
  }

  setNextViewFile(num: number) {
    let files = this.item.files.filter(x => x.type == 'file').map(x => x.id);
    let x = this.item.files.filter(x => x.type == 'file')[files.indexOf(this.viewFile.id) + num];
    if (x.extension == '.pdf') {
      this.displayDoc = fetch(this.getURL(x.id)).then(res => res.blob()).then(blob => {
        this.displayDoc = URL.createObjectURL(blob);
        this.viewFile = x;
      })
    }
    else this.viewFile = x;
  }
  
}